export type TypeSaveAsData = string | Blob | File;

export type TypeSaveAsConfig = {
    name?: string;
    extension?: string;
};

// ----------------------------------------------------------------------------

function saveAs(data: TypeSaveAsData, config: TypeSaveAsConfig = {}): void {
    let url: string;

    // If using file or blob
    if (data instanceof File || data instanceof Blob) {
        url = URL.createObjectURL(data);
    }
    // If using string
    else if (typeof data === 'string') {
        url = data;
    }
    //
    else {
        throw new Error('Unsupported data type for download.');
    }

    // ------------------------------------------------------------------------

    // If there is no name
    const fileName = config.name ?? Date.now().toString();
    const resolvedName =
        config.extension != null && !fileName.endsWith('.' + config.extension)
            ? `${fileName}.${config.extension}`
            : fileName;

    // ------------------------------------------------------------------------

    // Create element (link)
    const elLink = document.createElement('a');

    // Modern browsers
    if ('download' in elLink) {
        elLink.href = url;
        elLink.download = resolvedName;
        elLink.style.display = 'none';

        document.body.appendChild(elLink);

        elLink.click();
        elLink.remove();
    }
    // Old browsers
    else {
        window.open(url, '_blank');
    }

    // ------------------------------------------------------------------------

    // Clean up
    if (data instanceof File || data instanceof Blob) {
        setTimeout((): any => {
            URL.revokeObjectURL(url);
        }, 0);
    }
}

// ----------------------------------------------------------------------------

export default saveAs;
